// Utilidades mínimas para leer un JWT en el cliente sin agregar dependencias.
// Solo se usa para saber cuándo expira el token guardado — la validación real
// del token siempre ocurre en el backend.

export const decodeToken = (token) => {
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const json = decodeURIComponent(
      atob(padded)
        .split('')
        .map(c => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
};

// Fecha de expiración del token en milisegundos (epoch), o null si no se pudo determinar.
export const getTokenExpiryMs = (token) => {
  const decoded = decodeToken(token);
  if (!decoded?.exp) return null;
  return decoded.exp * 1000;
};

// true si el token ya expiró o no se pudo leer.
export const isTokenExpired = (token) => {
  const expiryMs = getTokenExpiryMs(token);
  if (!expiryMs) return true;
  return Date.now() >= expiryMs;
};
